module.exports = __webpack_public_path__ + "img/wenhao.442dc08c.png";